import { Injectable } from '@angular/core';
import { BaseFacade } from '../base/base.facade';
import { TranslateService } from '@ngx-translate/core';
import { DynamicSchemaFactory } from '../dynamic-schema.factory';
import { AppToken } from '../../../models/app-token';
import { SchemaPageStore } from './schema-page.store';
import { SchemaPageQuery } from './schema-page.query';
import { SchemaPageService } from './schema-page.service';
import { SchemaPageModel } from './schema-page.model';
import { Observable, of } from 'rxjs';
import { flatMap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class SchemaPageFacade extends BaseFacade {

  constructor(
    private readonly schemaPageService: SchemaPageService,
    schemaPageStore: SchemaPageStore,
    schemaPageQuery: SchemaPageQuery,
    dynamicSchemaFacto: DynamicSchemaFactory,
    translateService: TranslateService) {
    super(schemaPageService,
      schemaPageStore,
      schemaPageQuery,
      dynamicSchemaFacto.getDynamicSchemaFacade(AppToken.SCHEMA_PAGE_SCHEMA_NAME),
      translateService,
      AppToken.SCHEMA_PAGE_SCHEMA_NAME + '-facade'
      );
  }

  getSchemaPageByPageId(pageId: string): Observable<SchemaPageModel> {
    return this.schemaPageService.getByParentId(pageId, 'pageid').pipe(flatMap((contentList) => {
      return of(contentList.items[0]);
    }));
  }


  getSchemaPageByContentId(contentId: string, draftMode: boolean = false): Observable<SchemaPageModel> {
    return this.schemaPageService.getByParentId(contentId, 'contentid', 'id', draftMode).pipe(flatMap((contentList) => {
      return of(contentList.items[0]);
    }));
  }


  getSchemaPageByContentCode(contentCode: string): SchemaPageModel {



    return null;
  }

}
